<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { textAboveBackground } = $AppState.theme.colors;

  export let color = textAboveBackground;
</script>

<svg
  class="twism-collapsed-svg-wallet"
  width="36"
  height="38"
  viewBox="0 0 36 38"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M25.8156 11.6797V5.02107C25.8156 3.43841 25.8156 2.64708 25.4852 2.16076C25.1966 1.73588 24.7495 1.44724 24.2463 1.36082C23.6703 1.26191 22.9583 1.59353 21.5343 2.25676L4.80768 10.0471C3.53769 10.6386 2.90269 10.9343 2.4376 11.393C2.02644 11.7985 1.71259 12.2935 1.52005 12.8402C1.30225 13.4585 1.30225 14.1642 1.30225 15.5757V24.9996M26.7584 24.0482H26.7773M1.30225 17.7688L1.30225 30.3275C1.30225 32.4589 1.30225 33.5246 1.71329 34.3387C2.07486 35.0547 2.65179 35.6369 3.3614 36.0018C4.16813 36.4166 5.22419 36.4166 7.3363 36.4166H29.2098C31.3219 36.4166 32.3779 36.4166 33.1847 36.0018C33.8943 35.6369 34.4712 35.0547 34.8328 34.3387C35.2438 33.5246 35.2438 32.4589 35.2438 30.3275V17.7688C35.2438 15.6374 35.2438 14.5718 34.8328 13.7577C34.4712 13.0416 33.8943 12.4594 33.1847 12.0945C32.3779 11.6797 31.3219 11.6797 29.2098 11.6797L7.33631 11.6797C5.22419 11.6797 4.16813 11.6797 3.3614 12.0945C2.65179 12.4594 2.07486 13.0416 1.71329 13.7577C1.30225 14.5718 1.30225 15.6374 1.30225 17.7688ZM27.7013 24.0482C27.7013 24.5736 27.2791 24.9996 26.7584 24.9996C26.2377 24.9996 25.8156 24.5736 25.8156 24.0482C25.8156 23.5227 26.2377 23.0968 26.7584 23.0968C27.2791 23.0968 27.7013 23.5227 27.7013 24.0482Z"
    stroke={color}
    stroke-width="1.50312"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<style lang="scss">
  .twism-collapsed-svg-wallet {
    @media screen and (max-width: 468px) {
      width: 32px !important;
      height: 32px !important;
    }
  }
</style>
